/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ShippingDetailsQuotesTableRow_relevantShippingInfo$ref = any;
export type ShippingDetailsQuotesTable_relevantShippingInfo$ref = any;
export type ShippingDetailsQuotesTable_relevantShippingInfo = {
    readonly shipmentQuote: {
        readonly isCustom: boolean | null;
        readonly serviceMethod: {
            readonly region: {
                readonly code: string | null;
                readonly regionName: string | null;
                readonly regionBoundary: {
                    readonly type: {
                        readonly name: string | null;
                    } | null;
                } | null;
            } | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": ShippingDetailsQuotesTableRow_relevantShippingInfo$ref;
    readonly " $refType": ShippingDetailsQuotesTable_relevantShippingInfo$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ShippingDetailsQuotesTable_relevantShippingInfo",
    "type": "QueryRelevantShippingInfo",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "shipmentQuote",
            "storageKey": null,
            "args": null,
            "concreteType": "ShipmentQuote",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isCustom",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "serviceMethod",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "region",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Region",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "code",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "regionName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "regionBoundary",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "RegionBoundary",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "type",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "RegionBoundaryType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "name",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ShippingDetailsQuotesTableRow_relevantShippingInfo",
            "args": null
        }
    ]
} as any);
(node as any).hash = '7b515ac8b302e6b7eb599dc8de4ef75f';
export default node;
